// The signed-in staff member's session token (issue #251, see backend/
// middleware/staffAuth.js). localStorage rather than React state so the
// axios interceptor in axiosAuth.js can read it synchronously on every
// request — same reasoning as appPasswordStorage.js.
const STORAGE_KEY = 'optim_staff_session';

export function getSessionToken() {
  try {
    return window.localStorage.getItem(STORAGE_KEY);
  } catch {
    return null;
  }
}

export function setSessionToken(token) {
  try {
    if (!token) window.localStorage.removeItem(STORAGE_KEY);
    else window.localStorage.setItem(STORAGE_KEY, token);
  } catch {
    // Storage blocked — the session just won't survive a reload.
  }
}
